// @generated by protoc-gen-es v2.5.2 with parameter "target=ts,json_types=true"
// @generated from file audit/v1/audit.proto (package audit.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_common_v1_annotations } from "../../common/v1/annotations_pb";
import { file_common_v1_events } from "../../common/v1/events_pb";
import type { PaginationArguments, PaginationArgumentsJson, PaginationPageInfo, PaginationPageInfoJson } from "../../common/v1/pagination_pb";
import { file_common_v1_pagination } from "../../common/v1/pagination_pb";
import type { Creator, CreatorJson } from "../../common/v1/types_pb";
import { file_common_v1_types } from "../../common/v1/types_pb";
import type { StructJson, Timestamp, TimestampJson, Value, ValueJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_struct, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { JsonObject, Message as Message$1 } from "@bufbuild/protobuf";

/**
 * Describes the file audit/v1/audit.proto.
 */
export const file_audit_v1_audit: GenFile =
	/*@__PURE__*/
	fileDesc(
		"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",
		[file_common_v1_annotations, file_common_v1_events, file_common_v1_pagination, file_common_v1_types, file_google_protobuf_struct, file_google_protobuf_timestamp],
	);

/**
 * @generated from message audit.v1.AuditEvent
 */
export type AuditEvent = Message$1<"audit.v1.AuditEvent"> & {
	/**
	 * @generated from field: audit.v1.AuditLog log = 1;
	 */
	log?: AuditLog;
};

/**
 * @generated from message audit.v1.AuditEvent
 */
export type AuditEventJson = {
	/**
	 * @generated from field: audit.v1.AuditLog log = 1;
	 */
	log?: AuditLogJson;
};

/**
 * Describes the message audit.v1.AuditEvent.
 * Use `create(AuditEventSchema)` to create a new message.
 */
export const AuditEventSchema: GenMessage<AuditEvent, { jsonType: AuditEventJson }> = /*@__PURE__*/ messageDesc(file_audit_v1_audit, 0);

/**
 * @generated from message audit.v1.AuditLog
 */
export type AuditLog = Message$1<"audit.v1.AuditLog"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string org_id = 2;
	 */
	orgId: string;

	/**
	 * @generated from field: optional string workspace_id = 3;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: audit.v1.AuditType type = 4;
	 */
	type: AuditType;

	/**
	 * @generated from field: common.v1.Creator actor = 5;
	 */
	actor?: Creator;

	/**
	 * @generated from field: string entity_type = 6;
	 */
	entityType: string;

	/**
	 * @generated from field: string entity_id = 7;
	 */
	entityId: string;

	/**
	 * @generated from field: optional string related_entity_type = 8;
	 */
	relatedEntityType?: string;

	/**
	 * @generated from field: optional string related_entity_id = 9;
	 */
	relatedEntityId?: string;

	/**
	 * @generated from field: google.protobuf.Struct old_entity = 12;
	 */
	oldEntity?: JsonObject;

	/**
	 * @generated from field: google.protobuf.Struct new_entity = 13;
	 */
	newEntity?: JsonObject;

	/**
	 * @generated from field: audit.v1.Message message = 10;
	 */
	message?: Message;

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 11;
	 */
	createdAt?: Timestamp;
};

/**
 * @generated from message audit.v1.AuditLog
 */
export type AuditLogJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string org_id = 2;
	 */
	orgId?: string;

	/**
	 * @generated from field: optional string workspace_id = 3;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: audit.v1.AuditType type = 4;
	 */
	type?: AuditTypeJson;

	/**
	 * @generated from field: common.v1.Creator actor = 5;
	 */
	actor?: CreatorJson;

	/**
	 * @generated from field: string entity_type = 6;
	 */
	entityType?: string;

	/**
	 * @generated from field: string entity_id = 7;
	 */
	entityId?: string;

	/**
	 * @generated from field: optional string related_entity_type = 8;
	 */
	relatedEntityType?: string;

	/**
	 * @generated from field: optional string related_entity_id = 9;
	 */
	relatedEntityId?: string;

	/**
	 * @generated from field: google.protobuf.Struct old_entity = 12;
	 */
	oldEntity?: StructJson;

	/**
	 * @generated from field: google.protobuf.Struct new_entity = 13;
	 */
	newEntity?: StructJson;

	/**
	 * @generated from field: audit.v1.Message message = 10;
	 */
	message?: MessageJson;

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 11;
	 */
	createdAt?: TimestampJson;
};

/**
 * Describes the message audit.v1.AuditLog.
 * Use `create(AuditLogSchema)` to create a new message.
 */
export const AuditLogSchema: GenMessage<AuditLog, { jsonType: AuditLogJson }> = /*@__PURE__*/ messageDesc(file_audit_v1_audit, 1);

/**
 * @generated from message audit.v1.Message
 */
export type Message = Message$1<"audit.v1.Message"> & {
	/**
	 * @generated from field: string message_id = 1;
	 */
	messageId: string;

	/**
	 * @generated from field: repeated audit.v1.FormatParameter parameters = 2;
	 */
	parameters: FormatParameter[];
};

/**
 * @generated from message audit.v1.Message
 */
export type MessageJson = {
	/**
	 * @generated from field: string message_id = 1;
	 */
	messageId?: string;

	/**
	 * @generated from field: repeated audit.v1.FormatParameter parameters = 2;
	 */
	parameters?: FormatParameterJson[];
};

/**
 * Describes the message audit.v1.Message.
 * Use `create(MessageSchema)` to create a new message.
 */
export const MessageSchema: GenMessage<Message, { jsonType: MessageJson }> = /*@__PURE__*/ messageDesc(file_audit_v1_audit, 2);

/**
 * @generated from message audit.v1.FormatParameter
 */
export type FormatParameter = Message$1<"audit.v1.FormatParameter"> & {
	/**
	 * @generated from field: string key = 1;
	 */
	key: string;

	/**
	 * @generated from field: google.protobuf.Value value = 2;
	 */
	value?: Value;
};

/**
 * @generated from message audit.v1.FormatParameter
 */
export type FormatParameterJson = {
	/**
	 * @generated from field: string key = 1;
	 */
	key?: string;

	/**
	 * @generated from field: google.protobuf.Value value = 2;
	 */
	value?: ValueJson;
};

/**
 * Describes the message audit.v1.FormatParameter.
 * Use `create(FormatParameterSchema)` to create a new message.
 */
export const FormatParameterSchema: GenMessage<FormatParameter, { jsonType: FormatParameterJson }> = /*@__PURE__*/ messageDesc(file_audit_v1_audit, 3);

/**
 * @generated from message audit.v1.AuditRecord
 */
export type AuditRecord = Message$1<"audit.v1.AuditRecord"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string org_id = 2;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 3;
	 */
	workspaceId: string;

	/**
	 * @generated from field: audit.v1.AuditType type = 4;
	 */
	type: AuditType;

	/**
	 * @generated from field: common.v1.Creator actor = 5;
	 */
	actor?: Creator;

	/**
	 * @generated from field: string entity_type = 6;
	 */
	entityType: string;

	/**
	 * @generated from field: string entity_id = 7;
	 */
	entityId: string;

	/**
	 * @generated from field: optional string related_entity_type = 8;
	 */
	relatedEntityType?: string;

	/**
	 * @generated from field: optional string related_entity_id = 9;
	 */
	relatedEntityId?: string;

	/**
	 * @generated from field: google.protobuf.Struct old_entity = 12;
	 */
	oldEntity?: JsonObject;

	/**
	 * @generated from field: google.protobuf.Struct new_entity = 13;
	 */
	newEntity?: JsonObject;

	/**
	 * @generated from field: string message = 10;
	 */
	message: string;

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 11;
	 */
	createdAt?: Timestamp;
};

/**
 * @generated from message audit.v1.AuditRecord
 */
export type AuditRecordJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string org_id = 2;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 3;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: audit.v1.AuditType type = 4;
	 */
	type?: AuditTypeJson;

	/**
	 * @generated from field: common.v1.Creator actor = 5;
	 */
	actor?: CreatorJson;

	/**
	 * @generated from field: string entity_type = 6;
	 */
	entityType?: string;

	/**
	 * @generated from field: string entity_id = 7;
	 */
	entityId?: string;

	/**
	 * @generated from field: optional string related_entity_type = 8;
	 */
	relatedEntityType?: string;

	/**
	 * @generated from field: optional string related_entity_id = 9;
	 */
	relatedEntityId?: string;

	/**
	 * @generated from field: google.protobuf.Struct old_entity = 12;
	 */
	oldEntity?: StructJson;

	/**
	 * @generated from field: google.protobuf.Struct new_entity = 13;
	 */
	newEntity?: StructJson;

	/**
	 * @generated from field: string message = 10;
	 */
	message?: string;

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 11;
	 */
	createdAt?: TimestampJson;
};

/**
 * Describes the message audit.v1.AuditRecord.
 * Use `create(AuditRecordSchema)` to create a new message.
 */
export const AuditRecordSchema: GenMessage<AuditRecord, { jsonType: AuditRecordJson }> = /*@__PURE__*/ messageDesc(file_audit_v1_audit, 4);

/**
 * @generated from message audit.v1.DateRange
 */
export type DateRange = Message$1<"audit.v1.DateRange"> & {
	/**
	 * @generated from field: google.protobuf.Timestamp start_date = 1;
	 */
	startDate?: Timestamp;

	/**
	 * @generated from field: google.protobuf.Timestamp end_date = 2;
	 */
	endDate?: Timestamp;
};

/**
 * @generated from message audit.v1.DateRange
 */
export type DateRangeJson = {
	/**
	 * @generated from field: google.protobuf.Timestamp start_date = 1;
	 */
	startDate?: TimestampJson;

	/**
	 * @generated from field: google.protobuf.Timestamp end_date = 2;
	 */
	endDate?: TimestampJson;
};

/**
 * Describes the message audit.v1.DateRange.
 * Use `create(DateRangeSchema)` to create a new message.
 */
export const DateRangeSchema: GenMessage<DateRange, { jsonType: DateRangeJson }> = /*@__PURE__*/ messageDesc(file_audit_v1_audit, 5);

/**
 * @generated from message audit.v1.LogFilter
 */
export type LogFilter = Message$1<"audit.v1.LogFilter"> & {
	/**
	 * @generated from field: optional string workspace_id = 1;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: optional audit.v1.AuditType type = 2;
	 */
	type?: AuditType;

	/**
	 * @generated from field: optional common.v1.Creator actor = 3 [deprecated = true];
	 * @deprecated
	 */
	actor?: Creator;

	/**
	 * @generated from field: repeated common.v1.Creator actors = 4;
	 */
	actors: Creator[];

	/**
	 * @generated from field: optional string entity_type = 5;
	 */
	entityType?: string;

	/**
	 * @generated from field: optional string entity_id = 6;
	 */
	entityId?: string;

	/**
	 * @generated from field: optional string related_entity_type = 7;
	 */
	relatedEntityType?: string;

	/**
	 * @generated from field: optional string related_entity_id = 8;
	 */
	relatedEntityId?: string;
};

/**
 * @generated from message audit.v1.LogFilter
 */
export type LogFilterJson = {
	/**
	 * @generated from field: optional string workspace_id = 1;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: optional audit.v1.AuditType type = 2;
	 */
	type?: AuditTypeJson;

	/**
	 * @generated from field: optional common.v1.Creator actor = 3 [deprecated = true];
	 * @deprecated
	 */
	actor?: CreatorJson;

	/**
	 * @generated from field: repeated common.v1.Creator actors = 4;
	 */
	actors?: CreatorJson[];

	/**
	 * @generated from field: optional string entity_type = 5;
	 */
	entityType?: string;

	/**
	 * @generated from field: optional string entity_id = 6;
	 */
	entityId?: string;

	/**
	 * @generated from field: optional string related_entity_type = 7;
	 */
	relatedEntityType?: string;

	/**
	 * @generated from field: optional string related_entity_id = 8;
	 */
	relatedEntityId?: string;
};

/**
 * Describes the message audit.v1.LogFilter.
 * Use `create(LogFilterSchema)` to create a new message.
 */
export const LogFilterSchema: GenMessage<LogFilter, { jsonType: LogFilterJson }> = /*@__PURE__*/ messageDesc(file_audit_v1_audit, 6);

/**
 * @generated from message audit.v1.ListAuditLogsRequest
 */
export type ListAuditLogsRequest = Message$1<"audit.v1.ListAuditLogsRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string lang = 2;
	 */
	lang: string;

	/**
	 * @generated from field: audit.v1.LogFilter filter = 3;
	 */
	filter?: LogFilter;

	/**
	 * @generated from field: common.v1.PaginationArguments pagination = 4;
	 */
	pagination?: PaginationArguments;
};

/**
 * @generated from message audit.v1.ListAuditLogsRequest
 */
export type ListAuditLogsRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string lang = 2;
	 */
	lang?: string;

	/**
	 * @generated from field: audit.v1.LogFilter filter = 3;
	 */
	filter?: LogFilterJson;

	/**
	 * @generated from field: common.v1.PaginationArguments pagination = 4;
	 */
	pagination?: PaginationArgumentsJson;
};

/**
 * Describes the message audit.v1.ListAuditLogsRequest.
 * Use `create(ListAuditLogsRequestSchema)` to create a new message.
 */
export const ListAuditLogsRequestSchema: GenMessage<ListAuditLogsRequest, { jsonType: ListAuditLogsRequestJson }> = /*@__PURE__*/ messageDesc(file_audit_v1_audit, 7);

/**
 * @generated from message audit.v1.ListAuditLogsResponse
 */
export type ListAuditLogsResponse = Message$1<"audit.v1.ListAuditLogsResponse"> & {
	/**
	 * @generated from field: repeated audit.v1.AuditRecord logs = 1;
	 */
	logs: AuditRecord[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfo;
};

/**
 * @generated from message audit.v1.ListAuditLogsResponse
 */
export type ListAuditLogsResponseJson = {
	/**
	 * @generated from field: repeated audit.v1.AuditRecord logs = 1;
	 */
	logs?: AuditRecordJson[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfoJson;
};

/**
 * Describes the message audit.v1.ListAuditLogsResponse.
 * Use `create(ListAuditLogsResponseSchema)` to create a new message.
 */
export const ListAuditLogsResponseSchema: GenMessage<ListAuditLogsResponse, { jsonType: ListAuditLogsResponseJson }> = /*@__PURE__*/ messageDesc(file_audit_v1_audit, 8);

/**
 * @generated from enum audit.v1.AuditType
 */
export enum AuditType {
	/**
	 * @generated from enum value: AUDIT_TYPE_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: AUDIT_TYPE_CREATED = 2;
	 */
	CREATED = 2,

	/**
	 * @generated from enum value: AUDIT_TYPE_UPDATED = 3;
	 */
	UPDATED = 3,

	/**
	 * @generated from enum value: AUDIT_TYPE_DELETED = 4;
	 */
	DELETED = 4,

	/**
	 * @generated from enum value: AUDIT_TYPE_ARCHIVED = 5;
	 */
	ARCHIVED = 5,

	/**
	 * @generated from enum value: AUDIT_TYPE_RESTORED = 6;
	 */
	RESTORED = 6,

	/**
	 * @generated from enum value: AUDIT_TYPE_ADDED = 7;
	 */
	ADDED = 7,

	/**
	 * @generated from enum value: AUDIT_TYPE_REMOVED = 8;
	 */
	REMOVED = 8,

	/**
	 * @generated from enum value: AUDIT_TYPE_PUBLISHED = 9;
	 */
	PUBLISHED = 9,

	/**
	 * @generated from enum value: AUDIT_TYPE_ANALYTICS_DOWNLOADED = 10;
	 */
	ANALYTICS_DOWNLOADED = 10,

	/**
	 * @generated from enum value: AUDIT_TYPE_DEFAULT_SET = 11;
	 */
	DEFAULT_SET = 11,

	/**
	 * @generated from enum value: AUDIT_TYPE_MOVED = 12;
	 */
	MOVED = 12,

	/**
	 * @generated from enum value: AUDIT_TYPE_DOWNLOADED = 13;
	 */
	DOWNLOADED = 13,
}

/**
 * @generated from enum audit.v1.AuditType
 */
export type AuditTypeJson = "AUDIT_TYPE_UNSPECIFIED" | "AUDIT_TYPE_CREATED" | "AUDIT_TYPE_UPDATED" | "AUDIT_TYPE_DELETED" | "AUDIT_TYPE_ARCHIVED" | "AUDIT_TYPE_RESTORED" | "AUDIT_TYPE_ADDED" | "AUDIT_TYPE_REMOVED" | "AUDIT_TYPE_PUBLISHED" | "AUDIT_TYPE_ANALYTICS_DOWNLOADED" | "AUDIT_TYPE_DEFAULT_SET" | "AUDIT_TYPE_MOVED" | "AUDIT_TYPE_DOWNLOADED";

/**
 * Describes the enum audit.v1.AuditType.
 */
export const AuditTypeSchema: GenEnum<AuditType, AuditTypeJson> = /*@__PURE__*/ enumDesc(file_audit_v1_audit, 0);

/**
 * @generated from service audit.v1.AuditService
 */
export const AuditService: GenService<{
	/**
	 * @generated from rpc audit.v1.AuditService.ListAuditLogs
	 */
	listAuditLogs: {
		methodKind: "unary";
		input: typeof ListAuditLogsRequestSchema;
		output: typeof ListAuditLogsResponseSchema;
	};
}> = /*@__PURE__*/ serviceDesc(file_audit_v1_audit, 0);
